module.exports = __webpack_public_path__ + "static/hero-bea143c536794ab6aca956166973084e.jpg";